import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PageTitleService {
  title: string;
  redirectBackPath: string;

  getTitle(): string{
    return this.title;
  }

  setTitle(newTitle: string){
    this.title = newTitle; 
  }

  getRedirectBackPath(): string{
    return this.redirectBackPath;
  }

  setRedirectBackPath(newRedirectBackPath:string){
    this.redirectBackPath = newRedirectBackPath;
  } 

}
